









import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FieldValidationError extends Vue {
  @Prop({ type: Boolean, default: false }) isStatic!: boolean;
}
